import { addMFA as addMFAService, verifyTotpToken } from '../../../services';

import AuthActions from '../../../state/Auth.actions';

export const addMFA = mfaType => dispatch => {
    dispatch(AuthActions.setPreferredMfaBegin(mfaType));

    return addMFAService(mfaType)
        .then(response => {
            return dispatch(AuthActions.setPreferredMfaSuccess(mfaType, response));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.setPreferredMfaFailure(mfaType, message));

            throw message;
        });
};

export const verify = params => dispatch => {
    dispatch(AuthActions.verifyTotpBegin(params));

    return verifyTotpToken(params)
        .then(response => {
            dispatch(AuthActions.verifyTotpSuccess(params, response));

            return addMFA('TOTP')(dispatch);
        })
        .catch(error => {
            const { message = error } = error;
            dispatch(AuthActions.verifyTotpFailure(params, message));

            throw message;
        });
};
